// PerfBlockHeader.js — l'entête de bloc unique, partagée par Performance ET
// Settings. Elle existait auparavant en 11 copies (5 blocs Perf + 4 modales
// inline + Winners + Settings) qui divergeaient silencieusement. Une seule
// définition ici, un seul CSS (PerfBlockHeader.css), pour qu'elles ne puissent
// plus se contredire. Voir design-system.md §9-13 et le brief d'unification.
//
// Deux variantes :
//   • défaut ("block")  : entête d'un .perf-block / .sb-block / .winners-block.
//   • variant="modal"   : entête d'une modale (titre + actions + close ✕).
//
// L'icône est un ReactNode (SVG <Icon/> côté Perf, glyphe "◷" côté Settings).
//
// Since layout-unify (2026-10-05) the block variant renders the shared .tb-card-header
// (shared/layout.css), also used by the Scan tab. The perf-block-* class names stay on the
// elements as hooks (Settings collapsed state) but carry no styling of their own.
import React from 'react';
import '../shared/layout.css';
import './PerfBlockHeader.css';

export default function PerfBlockHeader({
  icon,
  title,
  subtitle,
  actions,
  // collapsible (blocs Settings) :
  collapsible = false,
  collapsed = false,
  onToggle,
  // variante :
  variant = 'block',
  onClose,
  className = '',
}) {
  if (variant === 'modal') {
    return (
      <div className={`perf-modal-header ${className}`.trim()}>
        <div className="perf-modal-title">{title}</div>
        {(actions || onClose) && (
          <div className="perf-modal-actions">
            {actions}
            {onClose && (
              <button type="button" className="perf-modal-close" onClick={onClose} aria-label="Close">✕</button>
            )}
          </div>
        )}
      </div>
    );
  }

  const clickable = collapsible && typeof onToggle === 'function';
  return (
    <div
      className={`tb-card-header perf-block-header${collapsible ? ' perf-block-header--clickable' : ''} ${className}`.trim()}
      onClick={clickable ? onToggle : undefined}
    >
      {icon != null && <span className="tb-card-ico perf-block-ico">{icon}</span>}
      <h2 className="tb-card-title perf-block-title">
        {title}
        {subtitle != null && subtitle !== '' && <span className="tb-card-subtitle perf-block-subtitle">{subtitle}</span>}
      </h2>
      {actions && (
        <div className="tb-card-actions perf-block-header-actions" onClick={(e) => e.stopPropagation()}>{actions}</div>
      )}
      {collapsible && <span className="perf-block-chev">{collapsed ? '▸' : '▾'}</span>}
    </div>
  );
}
